import {Route} from '@angular/router';
import {MainPageComponent} from './pages/main-page/main-page.component';
import {CompanyComponent} from './pages/company/company.component';
import {WorkComponent} from './pages/work/work.component';
import {ProjectComponent} from './pages/project/project.component';
import {PersonComponent} from './pages/person/person.component';
import {OrderComponent} from './pages/order/order.component';
import {LocationComponent} from './pages/location/location.component';
import {ItemComponent} from './pages/item/item.component';
import {GroupComponent} from './pages/group/group.component';
import {FileComponent} from './pages/file/file.component';
import {AuthGuard} from '@lib-ui/auth/auth-guard.service';
import {CategoryComponent} from './pages/category/category.component';
import {PriceListComponent} from './pages/price-list/price-list.component';
import {OrderEditorComponent} from './pages/order/order-editor/order-editor.component';
import {CustomFieldsConfigComponent} from './pages/custom-fields/custom-fields-config.component';
import {LogsComponent} from './pages/logs/logs.component';
import { UnsavedChangesGuard } from '@lib-shared/guard/can-deactivate-guard';
import { ReportComponent } from './pages/report/report.component';

export const appRoutes: Route[] = [
    {
        path: '',
        component: MainPageComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'company',
        component: CompanyComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'file',
        component: FileComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'group',
        component: GroupComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'item',
        component: ItemComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'location',
        component: LocationComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'order',
        component: OrderComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'order-editor',
        component: OrderEditorComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'order-editor/:id',
        component: OrderEditorComponent,
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
    },
    {
        path: 'person',
        component: PersonComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'project',
        component: ProjectComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'work',
        component: WorkComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'category',
        component: CategoryComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'price-list',
        component: PriceListComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'custom-fields',
        component: CustomFieldsConfigComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'logs',
        component: LogsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'report',
        component: ReportComponent,
        canActivate: [AuthGuard],
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];
